/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(function() {
    'use strict';
    var names = {
        display: 'services/display',
        vector: 'services/display/vector',
        trafficFlow: 'services/trafficFlow',
        traffic: '',
        search: '',
        routing: ''
    };
    /**
     * Immutable object with the names of the different API keys.
     */
    return Object.freeze(names);
});



// WEBPACK FOOTER //
// ./security/apiKeyNames.js